import React from 'react';
import PropTypes from 'prop-types';
import useRandomId from 'hooks/useRandomId';

const Refinery29 = ({ color }) => {
  const titleId = useRandomId('Refinery29-logo__title');

  return (
    <svg
      aria-labelledby={titleId}
      fill="none"
      height="17"
      role="img"
      viewBox="0 0 80 17"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id={titleId}>Refinery29 logo</title>

      <g id="press_logo-r29">
        <g id="Group">
          <path
            id="Shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.6058 5.58179C11.1797 5.58179 10.8009 5.70016 10.4931 5.9014C10.138 4.64664 9.04894 3.94824 7.39171 3.94824H4.78751V4.85971H7.46274C8.83587 4.85971 9.6408 5.60547 9.6408 6.89573C9.6408 8.186 8.83587 8.93175 7.46274 8.93175H7.43906L7.59295 8.70684C7.92439 8.20967 8.23216 7.72434 8.23216 7.26269C8.23216 6.3157 7.62846 5.59363 6.44473 5.59363C5.42672 5.59363 4.64546 6.37489 4.64546 7.2982H5.61612C5.61612 6.83655 5.92389 6.49326 6.43289 6.49326C6.98924 6.49326 7.24967 6.81287 7.24967 7.28636C7.24967 7.64148 7.01292 8.00844 6.76434 8.3754L6.3737 8.94359H4.78751V9.85506H5.77L4.06543 12.3409H8.16114V11.4294H5.73449L6.82352 9.84322H7.39171C7.48641 9.84322 7.58111 9.84322 7.67581 9.83139L10.5404 13.5601H11.7715L10.8245 12.3409L12.6238 9.71301C12.6571 9.66608 12.6908 9.6189 12.7247 9.57144L12.725 9.57103C13.1614 8.96035 13.63 8.3045 13.63 7.54678C13.6181 6.46959 12.7895 5.58179 11.6058 5.58179ZM10.221 11.5588L8.74136 9.65302C9.28588 9.47546 9.72386 9.19137 10.0435 8.80074C10.3986 9.25055 10.9549 9.53465 11.6178 9.53465H11.6652L10.221 11.5588ZM10.5875 7.55895C10.5875 8.15081 10.99 8.62431 11.6055 8.62431C12.2329 8.62431 12.6353 8.15081 12.6235 7.55895C12.6235 6.96708 12.221 6.49359 11.6055 6.49359C11.0491 6.49359 10.6704 6.88422 10.5993 7.39323V7.4169C10.5875 7.46425 10.5875 7.5116 10.5875 7.55895Z"
            fill={color || '#424242'}
          />
          <path
            id="Shape_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.880859 8.55327C0.880859 4.32735 4.31368 0.894531 8.5396 0.894531C12.7655 0.894531 16.1983 4.32735 16.1983 8.54143C16.1983 12.7792 12.7655 16.212 8.5396 16.212C4.31368 16.212 0.880859 12.7792 0.880859 8.55327ZM1.79181 8.55275C1.79181 12.2697 4.81032 15.3 8.53907 15.3C12.2678 15.3 15.2863 12.2697 15.2863 8.55275C15.2863 4.83583 12.256 1.80548 8.53907 1.80548C4.82216 1.80548 1.79181 4.83583 1.79181 8.55275Z"
            fill={color || '#424242'}
          />
        </g>
        <g id="Group_2">
          <path
            id="Shape_3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.1318 7.03218C26.1318 7.57151 25.8954 8.06394 25.529 8.40396C25.3517 8.5681 25.1271 8.7088 24.8552 8.79087L27.3965 11.8862H25.789L23.3659 8.90811H22.8931V11.8862H21.5811V5.15625H24.0515C24.7488 5.15625 25.198 5.34384 25.529 5.66041C25.8954 6.00042 26.1318 6.49285 26.1318 7.03218ZM23.9683 7.74762C24.3465 7.74762 24.512 7.66555 24.6302 7.5483C24.7484 7.41933 24.8311 7.23174 24.8193 7.03242C24.8193 6.84483 24.7484 6.63378 24.6302 6.51654C24.512 6.39929 24.3465 6.3055 23.9683 6.3055H22.8808V7.74762H23.9683Z"
            fill={color || '#424242'}
          />
          <path
            id="Path"
            d="M29.5947 8.84949H31.6751V7.70048H29.5947V6.30526H32.3488V5.15625H28.2827V11.8744H32.4434V10.7254H29.5947V8.84949Z"
            fill={color || '#424242'}
          />
          <path
            id="Path_2"
            d="M34.1577 11.8744H35.4697V8.84949H37.5501V7.70048H35.4697V6.30526H38.2238V5.15625H34.1577V11.8744Z"
            fill={color || '#424242'}
          />
          <rect
            id="Rectangle"
            x="39.5947"
            y="5.15625"
            width="1.31203"
            height="6.72991"
            fill={color || '#424242'}
          />
          <path
            id="Path_3"
            d="M47.4791 9.54124L43.6966 5.15625H42.7747V11.8744H44.0867V7.50116L47.8691 11.8744H48.7793V5.15625H47.4791V9.54124Z"
            fill={color || '#424242'}
          />
          <path
            id="Path_4"
            d="M52.0891 8.84949H54.1695V7.70048H52.0891V6.30526H54.8314V5.15625H50.7771V11.8744H54.9378V10.7254H52.0891V8.84949Z"
            fill={color || '#424242'}
          />
          <path
            id="Shape_4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M61.2021 7.03218C61.2021 7.57151 60.9657 8.06394 60.5993 8.40396C60.4102 8.5681 60.1974 8.7088 59.9137 8.80259L62.455 11.8862H60.8357L58.4362 8.90811H57.9634V11.8862H56.6514V5.15625H59.1218C59.8192 5.15625 60.2683 5.34384 60.5993 5.66041C60.9657 6.00042 61.2021 6.49285 61.2021 7.03218ZM59.0267 7.74762C59.405 7.74762 59.5705 7.66555 59.6887 7.5483C59.8187 7.41933 59.8896 7.23174 59.8896 7.03242C59.8896 6.84483 59.8187 6.63378 59.7005 6.51654C59.5823 6.39929 59.4168 6.3055 59.0386 6.3055H57.9511V7.74762H59.0267Z"
            fill={color || '#424242'}
          />
          <path
            id="Path_5"
            d="M65.1731 7.51289L63.6719 5.15625H62.1826L64.5112 8.83777V11.8744H65.8232V8.83777L68.1399 5.15625H66.6506L65.1731 7.51289Z"
            fill={color || '#424242'}
          />
          <path
            id="Path_6"
            d="M72.6319 9.00203C73.1047 8.39235 73.3648 7.86475 73.3648 7.0323V7.0323C73.3648 5.80122 72.3128 4.91016 71.1544 4.91016H71.1071C69.9487 4.91016 68.9677 5.76605 68.8968 7.00885H70.2088C70.2088 6.52815 70.6343 6.08261 71.1426 6.08261C71.6508 6.08261 72.0764 6.52815 72.0764 7.00885C72.0764 7.36059 72.0291 7.73578 71.5445 8.34546L68.6367 11.8628H73.6366V10.6904H71.2371L72.6319 9.00203Z"
            fill={color || '#424242'}
          />
          <path
            id="Shape_5"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M74.606 7.3259C74.606 6.00102 75.6816 4.92236 77.0054 4.92236C78.2702 4.92236 79.4877 5.83688 79.4877 7.279C79.4877 7.95903 79.1685 8.55698 78.8139 9.16666L77.2182 11.8868H75.788L77.0764 9.69426H76.9818C75.6934 9.69426 74.606 8.69768 74.606 7.3259ZM75.8237 7.32554C75.8237 7.99384 76.3675 8.53317 77.0412 8.53317C77.7031 8.53317 78.2587 7.98211 78.2587 7.32554C78.2587 6.65724 77.7149 6.1179 77.0412 6.1179C76.3675 6.1179 75.8237 6.65724 75.8237 7.32554Z"
            fill={color || '#424242'}
          />
        </g>
      </g>
    </svg>
  );
};

Refinery29.propTypes = {
  color: PropTypes.string,
}

export default Refinery29;
